import { Helmet } from 'react-helmet-async';

/**
 * Per-route SEO + JSON-LD injection.
 * Pass `schema` as a JS object (will be JSON.stringify'd) for any schema.org payload.
 * Multiple schemas can be passed as an array.
 */
export default function SEO({ title, description, canonical, image, schema, type = 'website' }) {
  const fullTitle = title?.includes('getbitsy') ? title : `${title} · getbitsy.ai`;
  const ogImg = image || 'https://getbitsy.ai/icons/icon-512.png';
  const schemas = Array.isArray(schema) ? schema : (schema ? [schema] : []);

  return (
    <Helmet>
      {title && <title>{fullTitle}</title>}
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}

      {title && <meta property="og:title" content={fullTitle} />}
      {description && <meta property="og:description" content={description} />}
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:type" content={type} />
      <meta property="og:image" content={ogImg} />

      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={fullTitle} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImg} />

      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
}
